(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fable-css-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fable-css-hero')) {
  customElements.define('fable-css-hero', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); }); }
    initialize() {
      this.button = this.querySelector('.fch__toggle');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.visible = false;
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.reduced.addEventListener('change', () => this.sync(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, { threshold:.05 });
      this.observer.observe(this);
      this.sync();
    }
    sync() {
      this.dataset.motion = this.visible && !this.paused && !this.reduced.matches && !document.hidden ? 'running' : 'paused';
      this.button.hidden = this.reduced.matches;
      this.button.textContent = this.paused ? this.button.dataset.play : this.button.dataset.pause;
      this.button.setAttribute('aria-pressed', String(this.paused));
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fable-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fable-marquee')) {
  customElements.define('fable-marquee', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.viewport = this.querySelector('.fbm-viewport');
      this.track = this.querySelector('.fbm-track');
      this.dialog = this.querySelector('dialog');
      this.originals = [...this.track.children];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.hovered = false; this.touching = false; this.focused = false; this.editing = false;
      this.until = 0; this.last = 0; this.cycle = 0;
      const listen = (target, name, fn) => target.addEventListener(name, fn, {signal});
      this.rebuild();
      this.resize = new ResizeObserver(() => this.rebuild());
      this.resize.observe(this.viewport);
      listen(this.viewport, 'pointerenter', e => { if (e.pointerType === 'mouse') this.hovered = true; });
      listen(this.viewport, 'pointerleave', () => { this.hovered = false; });
      listen(this.viewport, 'pointerdown', e => { this.touching = true; this.startX = e.clientX; this.dragged = false; });
      listen(this.viewport, 'pointermove', e => { if (this.touching && Math.abs(e.clientX - this.startX) > 8) this.dragged = true; });
      const release = () => { if(this.touching) { this.touching = false; this.until = performance.now() + 1500; } };
      listen(window, 'pointerup', release); listen(window, 'pointercancel', release);
      listen(this.viewport, 'wheel', () => {this.until = performance.now() + 1500;});
      listen(this.viewport, 'focusin', () => {this.focused = true;});
      listen(this.viewport, 'focusout', () => {this.focused = false;});
      listen(this.viewport, 'click', e => {
        const button = e.target.closest('.fbm-open');
        if (!button || this.dragged) return;
        const template = this.querySelector(`template[data-popup="${button.dataset.item}"]`);
        if (!template) return;
        this.opener = button;
        this.dialog.replaceChildren(template.content.cloneNode(true));
        this.dialog.showModal();
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      });
      listen(this.dialog, 'click', e => {
        if (e.target.closest('.fbm-close')) this.dialog.close();
        if (e.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if(e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
        }
      });
      listen(this.dialog, 'close', () => {
        document.documentElement.style.overflow = this.oldOverflow || '';
        this.opener?.focus({preventScroll:true});
      });
      listen(document, 'shopify:block:select', e => {
        const card = this.originals.find(c => c.dataset.block === e.detail.blockId);
        if(card) { this.editing = true; this.viewport.scrollLeft = card.offsetLeft - this.track.offsetLeft; }
      });
      listen(document, 'shopify:block:deselect', () => {this.editing = false;});
      this.tick = time => {
        const delta = this.last ? Math.min(time - this.last, 40) : 0; this.last = time;
        if (this.cycle && !document.hidden && !this.motion.matches && !this.hovered && !this.touching && !this.focused && !this.editing && !this.dialog.open && time > this.until) {
          this.position += delta * Number(this.dataset.speed) / 1000;
          if(this.position >= this.cycle * 2) this.position -= this.cycle;
          if(this.position < 1) this.position += this.cycle;
          this.viewport.scrollLeft = this.position;
        } else { this.position = this.viewport.scrollLeft; }
        this.frame = requestAnimationFrame(this.tick);
      };
      this.frame = requestAnimationFrame(this.tick);
    }
    rebuild() {
      const width = this.viewport.clientWidth;
      if(!width || width === this.measuredWidth) return;
      this.measuredWidth = width;
      this.track.querySelectorAll('[data-copy]').forEach(el => el.remove());
      if(!this.originals.length) return;
      const clone = card => {
        const copy = card.cloneNode(true);
        copy.dataset.copy = 'true'; copy.setAttribute('aria-hidden','true');
        copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('button').forEach(b => b.tabIndex = -1);
        this.track.append(copy);
      };
      const repeats = Math.max(1, Math.ceil(5 / this.originals.length));
      for(let i=1;i<repeats;i++) this.originals.forEach(clone);
      const base = [...this.track.children];
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.cycle = base.length * (this.originals[0].getBoundingClientRect().width + gap);
      base.forEach(clone); base.forEach(clone);
      this.position = this.cycle; this.viewport.scrollLeft = this.position;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); this.resize?.disconnect(); this.abort?.abort();
      if(this.dialog?.open) {this.dialog.close(); document.documentElement.style.overflow = this.oldOverflow || '';}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
